import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { RootState, useAppDisPatch } from '../../../redux/store';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';
import { bookmarkedLocumJobsActions } from '../../../redux/slices/bookmarkedLocumJobsSlice';

const useRemoveBookmarkJob = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();
  const bookmarkMapping = useSelector(
    (state: RootState) => state.bookmarkedLocumJobs.bookmarkMapping
  );

  const onRemoveBookmarkJobError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while removing bookmark'
    );
  };

  const removeBookmarkJob = (jobId: string) => {
    // Look up the corresponding bookmarkId from the Redux state.
    const mapping = bookmarkMapping.find((item) => item.jobId === jobId);
    if (!mapping) {
      toast.error('Bookmark not found for this job.');
      return;
    }
    const url: HttpConfig = {
      url: `jobs-service/bookmarks/${mapping.bookmarkId}`,
      method: 'delete',
      // data: { bookmarkId: mapping.bookmarkId },
    };

    request(
      url,
      (response: SuccessHttpResponse<any>) => {
        toast.success('bookmark removed successfully');
        // Remove the bookmark mapping and data from Redux.
        dispatch(bookmarkedLocumJobsActions.removeBookmarkMapping({ jobId }));
        dispatch(bookmarkedLocumJobsActions.removeBookmarkJobData({ jobId }));
      },
      setLoading,
      onRemoveBookmarkJobError
    );
  };

  return { removeBookmarkJob, loading };
};

export default useRemoveBookmarkJob;
